module.exports = __webpack_public_path__ + "img/q3.b5ccf019.png";